import { styled, Box, Typography } from "@mui/material";
import { dumontColors } from "../../../colors";

export const ItemContainer = styled(Box)({
  height: "62.58px",
  padding: "12px 0 12px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  borderBottom: `1px solid ${dumontColors.gray100}`,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: dumontColors.backgroundHover,
  },
});

export const ItemTitle = styled(Typography)({
  fontSize: 13,
  fontWeight: 500,
  color: dumontColors.text,
  lineHeight: 1.4,
  fontFamily: "Manrope",
});

export const ItemSubtitle = styled(Typography)({
  fontSize: 11,
  fontWeight: 400,
  color: dumontColors.textTertiary,
  lineHeight: 1.4,
  fontFamily: "Manrope",
});
